"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconChevron = _interopRequireDefault(require("../../../shared/icons/icon-chevron.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MainImage = function MainImageComponent(_ref) {
  var carouselImages = _ref.carouselImages,
      displayedImageIndex = _ref.displayedImageIndex,
      selectedImageIndex = _ref.selectedImageIndex,
      setSelectedImageindex = _ref.setSelectedImageindex,
      showCarousel = _ref.showCarousel;
  var displayedLargeImage = carouselImages[displayedImageIndex] || {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details__carousel__wrap"
  }, showCarousel && /*#__PURE__*/_react["default"].createElement("button", {
    className: "product-details__carousel__slide--prev",
    onClick: function onClick() {
      return setSelectedImageindex(displayedImageIndex - 1);
    },
    type: "button",
    tabIndex: 0,
    disabled: selectedImageIndex === 0
  }, /*#__PURE__*/_react["default"].createElement(_iconChevron["default"], {
    className: "product-details__carousel__icon-prev"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details__carousel__slide--main"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "product-details__carousel__image",
    alt: displayedLargeImage.alt,
    src: displayedLargeImage.url
  })), showCarousel && /*#__PURE__*/_react["default"].createElement("button", {
    className: "product-details__carousel__slide--next",
    onClick: function onClick() {
      return setSelectedImageindex(displayedImageIndex + 1);
    },
    type: "button",
    tabIndex: 0,
    disabled: selectedImageIndex === carouselImages.length - 1
  }, /*#__PURE__*/_react["default"].createElement(_iconChevron["default"], {
    className: "product-details__carousel__icon-next"
  })));
};

MainImage.propTypes = {
  carouselImages: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  displayedImageIndex: _propTypes["default"].number.isRequired,
  selectedImageIndex: _propTypes["default"].number.isRequired,
  setSelectedImageindex: _propTypes["default"].func.isRequired,
  showCarousel: _propTypes["default"].bool
};
MainImage.defaultProps = {
  showCarousel: false
};
var _default = MainImage;
exports["default"] = _default;